module.exports = __webpack_public_path__ + "assets/5e329f3c7b709afdcb17e35f1d871951.jpg";